import React from 'react'
import { COLORES } from '../../../../config/colores'
import { IconButton } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CamposCargaConRemito from './CamposCargaConRemito'
import { connect } from 'react-redux'

function PesadoConRemitoCampos (props) {
  const { resetPesado, submitDatos } = props

  const handleSubmit = (e) => {
    e.preventDefault()
    submitDatos()
  }

  return (
    <div className='container-campos-form campos-remito'>

      <IconButton onClick={resetPesado} style={{ outline: 'none' }}>
        <ArrowBackIcon style={{ color: COLORES.grey.medium }} />
      </IconButton>

      <CamposCargaConRemito
        exportador={props.exportador}
        planta={props.planta}
        cereal={props.cerealRemito}
        handleSubmit={handleSubmit}
        style={{ margin: '2%', width: '98%' }}
      />

    </div>
  )
}

const mapStateToProps = (state) => ({
  exportador: state.pesado.exportadorRemito,
  cerealRemito: state.pesado.cerealRemito
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(PesadoConRemitoCampos)
